import { render, staticRenderFns } from "./CpttEditMain.vue?vue&type=template&id=13d348d6&scoped=true&"
import script from "./CpttEditMain.vue?vue&type=script&lang=js&"
export * from "./CpttEditMain.vue?vue&type=script&lang=js&"
import style0 from "./CpttEditMain.vue?vue&type=style&index=0&id=13d348d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d348d6",
  null
  
)

export default component.exports